






































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BFormSelect,
  BRow,
  BTable,
  BSpinner,
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { AgenceCreateModel } from "@/api/models/structures/agence";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import Categories from "@/api/models/enums/categoriesEnum";
import { droitDiffusion } from "@/api/models/droitsDiffusion/droitDiffusion";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
  },
  name: "create-agence",
})
export default class CreateAgence extends Vue {
  @Prop({ required: true, type: Boolean })
  isAddNewAgenceSidebarActive!: boolean;
  loading = false;

  required = required;
  categories = Categories;

  newAgence: AgenceCreateModel = {};

  resetForm() {
    this.newAgence = {};
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.structures
      .createAgenceOnStructure(this.$route.params.id, this.newAgence)
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Création d'un agence",
            text: "Agence créée avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-structures");
        this.$emit("update:is-add-new-agence-sidebar-active", false);
        this.loading = false;
      });
  }
}
